export interface SplitPanePersistentStatePanel {
  id: string;
  index: number;
  size: number;
}

export interface SplitPanePersistentState {
  panels: SplitPanePersistentStatePanel[];
}

/** Use the same validated cookie on the server and during hydration. */
export function parseSplitPaneLayout(cookie: string | undefined): SplitPanePersistentState | null {
  if (!cookie) return null;
  try {
    const state = JSON.parse(atob(cookie));
    if (
      !Array.isArray(state?.panels) ||
      !state.panels.every(
        (panel: SplitPanePersistentStatePanel) =>
          panel &&
          typeof panel.id === "string" &&
          panel.id.length > 0 &&
          Number.isInteger(panel.index) &&
          panel.index >= 0 &&
          Number.isFinite(panel.size) &&
          panel.size >= 0 &&
          panel.size <= 100,
      )
    )
      return null;
    return state;
  } catch {
    return null;
  }
}
